import { useEffect, useState } from 'react'
import MenuButton from '../components/MenuButton'
import { RankingTable } from '../components/RankingTable'
import { useGame } from '../contexts/GameContext'
import { cn } from '../lib/utils'
import { getRankingFromStorage, saveRankingInStorage } from '../storage'
import { secondsToMinutes } from '../utils/format-time'

export function GameOverScreen() {
	const { gameData, currentScreen, changeScreen } = useGame()
	const [playerName, setPlayerName] = useState('')
	const [saved, setSaved] = useState(false)
	const [inputFocused, setInputFocused] = useState(false)

	const saveScore = () => {
		if (playerName.trim()) {
			const newRanking = getRankingFromStorage()
			const existingIndex = newRanking.findIndex(rank => rank.name === playerName.trim())
			
			const newEntry = {
				name: playerName.trim(),
				score: gameData.score,
				matchTime: gameData.matchTime,
				date: new Date().toLocaleDateString(),
			}

			if (existingIndex >= 0) {
				newRanking[existingIndex] = newEntry
			} else {
				newRanking.push(newEntry)
			}

			newRanking.sort((a, b) => b.score - a.score)
			saveRankingInStorage(newRanking.slice(0, 10))
			setSaved(true)
			setInputFocused(false)
		}
	}

	useEffect(() => {
		if (currentScreen === 'gameOver' || currentScreen === 'timeUp') {
			setSaved(false)
			setPlayerName('')
		}
	}, [currentScreen])

	if (inputFocused && !saved && window.innerWidth < 1024) {
		return (
			<div className="fixed inset-0 z-50 flex items-start justify-center bg-white pt-4">
				<div className="grid grid-cols-3 place-items-center">
					<div>
						<p className="font-bold text-gray-700 text-sm">
							Tempo de Partida: {secondsToMinutes(gameData.matchTime)}
						</p>
						<p className="text-center font-bold text-gray-700 text-sm">
							Pontuação Final: {gameData.score}
						</p>
					</div>

					<input
						type="text"
						placeholder="Digite seu nome"
						value={playerName}
						onChange={(e) => setPlayerName(e.target.value)}
						onKeyDown={(e) => e.key === 'Enter' && saveScore()}
						onBlur={() => setInputFocused(false)}
						className="rounded-lg border-2 border-gray-300 p-4 text-center text-lg"
						maxLength={20}
						autoFocus
					/>

					<button
						type="button"
						onClick={saveScore}
						className="rounded-lg border-2 border-[#8cc63f] bg-[#8cc63f] px-6 py-4 font-bold text-lg text-white transition-all duration-300 hover:shadow-lg"
					>
						SALVAR PONTUAÇÃO
					</button>
				</div>
			</div>
		)
	}

	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300',
				{
					'pointer-events-auto opacity-100':
						currentScreen === 'gameOver' || currentScreen === 'timeUp',
				}
			)}
		>
			<div className="relative h-dvh w-full overflow-hidden">
				<img src="./assets/fundo.png" alt="Fundo" className="absolute h-dvh w-dvw object-fill" />

				{currentScreen === 'gameOver' ? (
					<img
						src="./assets/boneco_chances_acabaram.png"
						alt="Fundo"
						className="absolute bottom-0 left-20 h-[100%]"
					/>
				) : (
					<img
						src="./assets/boneco_tempo_acabou.png"
						alt="Fundo"
						className="absolute bottom-0 left-32 h-[100%]"
					/>
				)}

				<MenuButton
					src="./assets/botoes/botao_fechar.svg"
					alt="Fechar"
					onClick={() => changeScreen('home')}
					title="Voltar para Home"
					className="absolute top-5 right-5 size-10"
				/>

				{!saved && (
					<div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 z-20 transform">
						<div className="w-full max-w-xs rounded-3xl bg-white/95 p-4 text-center shadow-2xl lg:max-w-md">
							<div className="mb-6 font-bold text-2xl text-gray-700">
								Tempo de Partida: {secondsToMinutes(gameData.matchTime)}
							</div>
							<div className="mb-6 font-bold text-2xl text-gray-700">
								Pontuação Final: {gameData.score}
							</div>

							<div>
								<input
									type="text"
									placeholder="Digite seu nome"
									value={playerName}
									onChange={(e) => setPlayerName(e.target.value)}
									onKeyDown={(e) => e.key === 'Enter' && saveScore()}
									onFocus={() => setInputFocused(true)}
									className="mb-4 w-full rounded-lg border-2 border-gray-300 p-3 text-center text-lg"
									maxLength={20}
								/>
								<button
									type="button"
									onClick={saveScore}
									className="w-full rounded-lg bg-gradient-to-r from-green-500 to-green-600 px-6 py-3 font-bold text-lg text-white transition-all duration-300 hover:shadow-lg"
								>
									SALVAR PONTUAÇÃO
								</button>
							</div>
						</div>
					</div>
				)}

				<div className="absolute top-[5%] right-[5%] h-[70%]">
					<RankingTable />
				</div>

				<MenuButton
					src="./assets/botoes/jogar_novamente.svg"
					alt="Iniciar"
					onClick={() => changeScreen('game')}
					title="Jogar novamente"
					className="absolute right-[8%] bottom-[10%] h-[12%] w-[20%]"
				/>
			</div>
		</div>
	)
}

export default GameOverScreen
